import { BASE_URL } from './../config';

export async function adminLogin(account_name, password, captchaId, captchaAnswer) {
  try {
    const response = await fetch(`${BASE_URL}/admin-auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ account_name, password, captchaId, captchaAnswer })
    });

    const data = await response.json();

    if (!response.ok) {
      return { success: false, message: data.message };
    }

    return { success: true, data };
  } catch (error) {
    return { success: false, message: 'خطا در ارتباط با سرور.' };
  }
}
// --- مدیریت وبلاگ ---
export function getAdminBlogCategories(token) {
  return adminFetch('/admin/blog/categories', 'GET', token);
}
export async function getAdminCaptcha() {
  try {
    const response = await fetch(`${BASE_URL}/admin-auth/captcha/generate`);
    const data = await response.json();
    if (!response.ok) return { success: false, message: 'خطا در دریافت کد امنیتی.' };
    return { success: true, data };
  } catch (error) {
    return { success: false, message: 'خطا در ارتباط با سرور.' };
  }
}

export function getAdminBlogPosts(token, categoryId = '', search = '', page = 1) {
  const params = new URLSearchParams({ categoryId, search, page });
  return adminFetch(`/admin/blog/posts?${params.toString()}`, 'GET', token);
}

export function getAdminBlogPost(token, id) {
  return adminFetch(`/admin/blog/posts/${id}`, 'GET', token);
}

export async function saveAdminBlogPost(token, { id, categoryId, title, summary, isPublished, coverFile, articleFile }) {
  try {
    const formData = new FormData();
    formData.append('categoryId', categoryId);
    formData.append('title', title);
    formData.append('summary', summary || '');
    formData.append('isPublished', isPublished ? 'true' : 'false');
    if (coverFile) formData.append('cover', coverFile);
    if (articleFile) formData.append('articleFile', articleFile);

    const url = id ? `${BASE_URL}/admin/blog/posts/${id}` : `${BASE_URL}/admin/blog/posts`;
    const method = id ? 'PUT' : 'POST';

    const response = await fetch(url, {
      method,
      headers: { Authorization: `Bearer ${token}` },
      body: formData
    });

    const data = await response.json();
    if (!response.ok) return { success: false, message: data.message };
    return { success: true, data };
  } catch (error) {
    return { success: false, message: 'خطا در ذخیره مقاله.' };
  }
}
export function deleteAdminBlogPost(token, id) {
  return adminFetch(`/admin/blog/posts/${id}`, 'DELETE', token);
}
// --- محدودیت دانلود روزانه ---
export function getDailyLimitAdmin(token) {
  return adminFetch('/admin/settings/daily-download-limit', 'POST', token);
}
export function updateDailyLimit(token, limit) {
  return adminFetch('/admin/settings/daily-download-limit', 'PUT', token, { limit });
}
// --- مدیریت درخواست‌های فایل ---
export function getAdminRequests(token, status = '', page = 1) {
  const params = new URLSearchParams({ status, page });
  return adminFetch(`/admin/requests?${params.toString()}`, 'POST', token);
}
export function updateRequestStatus(token, requestId, status, adminNote = '') {
  return adminFetch(`/admin/requests/${requestId}/status`, 'PUT', token, { status, adminNote });
}
export function deleteAdminRequest(token, requestId) {
  return adminFetch(`/admin/requests/${requestId}`, 'DELETE', token);
}
// --- تنظیمات سایت ---
export function getSingleFilePriceAdmin(token) {
  return adminFetch('/admin/settings/single-file-price', 'POST', token);
}
export function updateSingleFilePrice(token, price) {
  return adminFetch('/admin/settings/single-file-price', 'PUT', token, { price });
}
// --- مدیریت پلن‌ها ---
export function getAdminPlans(token) {
  return adminFetch('/admin/plans', 'POST', token);
}
export function addAdminPlan(token, title, durationDays, price) {
  return adminFetch('/admin/plans', 'POST', token, { title, durationDays, price });
}
export function updateAdminPlan(token, id, title, durationDays, price) {
  return adminFetch(`/admin/plans/${id}`, 'PUT', token, { title, durationDays, price });
}
export function deleteAdminPlan(token, id) {
  return adminFetch(`/admin/plans/${id}`, 'DELETE', token);
}
export async function getAdminStats(token) {
  return adminFetch('/admin/stats', 'POST', token);
}
// --- مدیریت کاربران ---
export function getAdminUsers(token, page = 1, search = '') {
  const params = new URLSearchParams({ page, search });
  return adminFetch(`/admin/users?${params.toString()}`, 'POST', token);
}

export function toggleUserBlock(token, userId, blocked) {
  return adminFetch(`/admin/users/${userId}/block`, 'PUT', token, { blocked });
}

export function deleteAdminUser(token, userId) {
  return adminFetch(`/admin/users/${userId}`, 'DELETE', token);
}
// --- نوع محصولات ---
export function getAdminProductTypes(token) {
  return adminFetch('/admin/products/types', 'GET', token);
}
export function addAdminProductType(token, name) {
  return adminFetch('/admin/products/types', 'POST', token, { name });
}
export function updateAdminProductType(token, id, name) {
  return adminFetch(`/admin/products/types/${id}`, 'PUT', token, { name });
}
export function deleteAdminProductType(token, id) {
  return adminFetch(`/admin/products/types/${id}`, 'DELETE', token);
}

// --- برندها ---
export function getAdminBrands(token, productTypeId) {
  return adminFetch(`/admin/products/brands/${productTypeId}`, 'GET', token);
}
export function addAdminBrand(token, productTypeId, name) {
  return adminFetch('/admin/products/brands', 'POST', token, { productTypeId, name });
}
export function updateAdminBrand(token, id, name) {
  return adminFetch(`/admin/products/brands/${id}`, 'PUT', token, { name });
}
export function deleteAdminBrand(token, id) {
  return adminFetch(`/admin/products/brands/${id}`, 'DELETE', token);
}

// --- فایل‌ها ---
export function getAdminFiles(token, brandId, search = '') {
  const query = search ? `?search=${encodeURIComponent(search)}` : '';
  return adminFetch(`/admin/products/files/${brandId}${query}`, 'GET', token);
}

export async function uploadAdminFile(token, { brandId, file, displayName, description }) {
  try {
    const formData = new FormData();
    formData.append('brandId', brandId);
    formData.append('file', file);
    if (displayName) formData.append('displayName', displayName);
    if (description) formData.append('description', description);

    const response = await fetch(`${BASE_URL}/admin/products/files`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` }, // ⚠️ Content-Type رو دستی ست نکن، مرورگر خودش با boundary درست می‌کنه
      body: formData
    });

    const data = await response.json();

    if (!response.ok) {
      return { success: false, message: data.message };
    }

    return { success: true, data };
  } catch (error) {
    return { success: false, message: 'خطا در آپلود فایل.' };
  }
}

export function updateAdminFile(token, id, displayName, description) {
  return adminFetch(`/admin/products/files/${id}`, 'PUT', token, { displayName, description });
}
export function deleteAdminFile(token, id) {
  return adminFetch(`/admin/products/files/${id}`, 'DELETE', token);
}

// تابع کمکی مشترک
async function adminFetch(endpoint, method, token, body = null) {
  try {
    const config = {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };
    if (body) config.body = JSON.stringify(body);

    const response = await fetch(`${BASE_URL}${endpoint}`, config);
    const data = await response.json();

    if (!response.ok) {
      return { success: false, message: data.message };
    }

    return { success: true, data };
  } catch (error) {
    return { success: false, message: 'خطا در ارتباط با سرور.' };
  }
}